import React from 'react';
import styled from 'styled-components';
import { motion, useScroll, useSpring } from 'framer-motion';
import { gradients, zIndex } from '../../styles/theme';

const ProgressBarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: transparent;
  z-index: ${zIndex.tooltip + 2}; /* Navbar'ın (100) ve diğer her şeyin üstünde */
  pointer-events: none;
`;

const ProgressBar = styled(motion.div)`
  height: 100%;
  background: ${gradients.primary};
  transform-origin: 0%;
  box-shadow: 0 0 10px rgba(233, 30, 99, 0.5);
  will-change: transform;
  transform: translateZ(0);
`;

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <ProgressBarContainer>
      <ProgressBar style={{ scaleX }} />
    </ProgressBarContainer>
  );
};

export default ScrollProgress;
